export const brandLogos = [
  "/assets/img/brand/brand-logo.png",
  "/assets/img/brand/brand-logo-2.png",
  "/assets/img/brand/brand-logo-3.png",
  "/assets/img/brand/brand-logo-4.png",
  "/assets/img/brand/brand-logo-5.png",
  "/assets/img/brand/brand-logo.png",
  "/assets/img/brand/brand-logo-2.png",
  "/assets/img/brand/brand-logo-3.png",
  "/assets/img/brand/brand-logo-4.png",
  "/assets/img/brand/brand-logo-5.png",
];
